// access localized strings by using the following lines of code
// import {useStore} from "react-redux";
// const i18n = useStore().getState().i18n;
// e.g. i18n.forgot_password => "Passwort vergessen?" (de)

function i18n() {
  const language = "de";

  // TODO: get user language from store

  const localizedStrings = {
    // English language
    en: {
      change_password: "Change Password",

      update_user: "Update new User",
      year: "Year",
      admin_scope_header: "Dashboard",
      admin_scope_header_desc:
        "Here you can create new users for MesuLink within your organization.",

      user_table_status: "status",
      user_table_Vorname: "First name",
      user_table_Nachname: "Last name",
      user_table_Benutzertyp: "User type",
      user_table_email: "E-mail address",

      land_germany_name: "Germany",
      land_germany_value: "en",

      land_austria_name: "Austria",
      land_austria_value: "en",

      land_swiss_name: "Swiss",
      land_swiss_value: "en",

      land_checkrepulic_name: "czeckreuplic",
      land_checkrepublic_value: "en",

      land_poland_name: "Poland",
      land_poland_value: "en",

      create_equipment_title: "Create new equipment",

      create_site_title: "Create new Site",
      create_area_title: "Create New Area",

      update_site_title: "Update Site",
      update_area_title: "Update Area",

      dashboard_initial_factory_title: "Create works",
      dashboard_initial_equipment_title: "Create and assign equipment",
      dashboard_initial_users_title: "Create additional 247UpTime users",

      dashboard_initial_state_title:
        "Hello, %s!<br> Continue setting up 247UpTime.",
      dashboard_initial_state_description:
        "After the initial setup, you can create additional works, equipment and users at any time.",

      construction_year: "Construction Year",
      carry_now: "carry out now",
      footer_contact: "Contact",
      empty_dashboard_button: "Go to Profile",
      empty_dashboard_title: "Sie haben noch keine Maschinen abonniert",
      empty_dashboard_desc:
        "Um Maschinen zu abonnieren müssen Sie in Ihrem Userprofil im Bereich , Ihre Maschinen die für Sie relevanten Werke oder Maschinen Pools auswählen.",
      export_machine_details: "Export Machines Data",
      footer_data_protection: "data protection",
      footer_impressum: "imprint",
      equipment_serial_number: "Serial Number",
      save: "Save",
      next_appointment: "Next Appointment",
      due_on: "Due on",
      rotation: "Rotation",
      reported: "Reported",
      no_notifications:
        "No new notifications. We’ll notifiy you as soon as there are new incidents.",
      sites: "Sites",
      counter_Type: "Counter Type",
      add_new_counter: "NEW",
      tab_counters: "Counters",
      streetnumber: "Street",
      postalCode: "Postal Code",
      city: "City",
      firmName: "Firm Name",
      homePage: "Home Page",
      land: "Country",
      firm_details: "DETAILS ABOUT YOUR COMPANY",
      email: "Email address",
      password: "Password",
      forgot_password: "Forgot password?",
      loginHeading: "Log in",
      loginButton: "Log in",
      registration: "Registration",
      no_account: "You dont have any account?",
      register_for_free: "Register for free",
      searchplaceholder_tablet: "Search for machines, …",
      searchplaceholder_phone: "Search for machines, etc.",
      createnewissue: "Create new issue",
      update_notification: "Edit Notification",
      opennotifications: "Open Notifications",
      machineparks: "Machine parks",
      machinepark: "Machine park",
      all_machineparks: "All Machine parks",
      factorysections: "Factory sections",
      machinecategory: "Machine category",
      machinestatus: "Machine status",
      groupby: "Group by",
      timerange: "Time range",
      show_n_more: "Show %s more",
      show_less: "Show less",
      // empty_notifications: 'There are currently no unresolved issues. Keep it up!',
      empty_notifications: "derzeit keine",
      notification_singular: "Notification",
      notification_plural: "Notifications",
      // avg_solutiontime: 'Ø Solution Time',
      avg_solutiontime: "MTTR",
      incidents: "Incidents",
      statistics: "Statistics",
      new_issue: "New Issue",
      create_new_notification: "Create New Notification",
      save_notification: "Save",
      filter_sorting: "Filter & Sorting",
      filter: "Filter",
      sorting: "Sorting",
      unresolved: "unresolved",
      day: "day",
      days: "days",
      empty_machineparks:
        "No machine parks have been set up yet. Please contact the administrator.",
      undisturbed: "undisturbed",
      disturbed: "Störung",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Machine Parks",
      tab_messages: "Messages",
      super_tab_clients: "Clients",
      super_tab_users: "Users",
      super_tab_brands: "Brands",
      super_tab_equipment_types: "Equipment Types",
      tab_notifications: "Notifications",
      manufacturer_serial_number: "Manufacturer Serial Number",
      heading_latest_notifications:
        "Latest Notifications & Scheduled Maintenance",
      go_to_machine_history: "Go to Machine History",
      heading_responsible: "Responsible",
      heading_manufacturer_service: "Manufacturer Service",
      heading_life_cycle: "Life Cycle",
      notificationtype: "Notification type",
      built_year: "Built year",
      empty_history: "The machine history does not show any notifications yet.",
      today: "Today",
      heading_documentation: "Documentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Document",
      file_ods: "ODS Spreadsheet",
      file_image: "Image",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interal Resources",
      hasmanufacturerattchment: "Manufacturer Resources",
      add_new_resource: "add new resource",
      add_ressource: "Add resource",
      upload_file: "Upload file",
      resource_vendor: "Classification",
      resource_type: "Type",
      resource_type_file: "File",
      resource_type_link: "Link",
      resource_type_photo: "Photo",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Change file",
      resource_name: "Resource title",
      resource_description: "Description (optional)",
      resource_language: "Language",
      resource_scope: "Scope",
      button_cancel: "cancel",
      button_yes: "Yes",
      button_no: "No",
      empty_resources: "No resources have been added to this machine yet.",
      button_done: "Done",
      select_multiple_n: "multiple (%s)",
      header_data: "Header Data",
      referred_to_machine: "Concerned Machine",
      notification_title: "Notification Title",
      helpertext_notification_title: 'e.g. "Main spindle faulty"',
      referred_to_assembly: "Concerned Assembly",
      date: "Date",
      time: "Time",
      problem_solution_status: "Status",
      notification_description: "Notification description",
      error_code: "Error code (optional)",
      describe_notification: "Describe the notification…",
      add_photos_videos: "Add photos/videos",
      capture_photo: "Capture new photo",
      capture_video: "Capture new video",
      add_from_gallery: "Add from gallery",
      add_attachments: "Add attachments",
      enter_description: "Enter description…",
      change_attachments: "Change attachments",
      notification_sucessfully_created:
        "The notification was successfully created",
      discuss_notification: "Discuss notification",
      go_to_machine: "go to machine",
      notificationtype_from: "%notificationtype from %datetime",
      reported_by: "reported by",
      machine: "Machine",
      images: "Images",
      no_images_yet: "No images have been added to this notification yet.",
      attachments: "Attachments",
      edit_notification: "Edit notification",
      notification_solved: "The notification has been successfully resolved.",
      close_notification_heading: "Close notification",
      close_notification_text:
        "Do you want to mark the notification as resolved and inform all participating instances about it?",
      settings: "Settings",
      chat_notifications: "Chat notifications",
      automatic_translation: "Automatic translation",
      activate: "activate",
      target_language: "Target language",
      involved_contacts_heading: "Involved Contacts",
      search_contacts: "Search contacts…",
      empty_discussion_contacts:
        "No contacts have been added to this discussion yet.",
      discussion_heading: "Discussion",
      error_chatroom_loading: "Failed to load chat room.",
      error_email_required: "Please enter your email address",
      error_email_format: "This is no valid email address",
      error_password_required: "Please enter your password",
      error_password_wrong: "Email and password do not match",
      enter_message: "Enter message…",
      time_h: "h",
      alert_trash_changes_body: "Do you want to discard the changes you made?",
      button_save_changes: "Save changes",
      logout: "Logout",
      all_notificationtypes: "all notification types",
      notificationtype_malfunction: "Malfunction",
      notificationtype_abnormality: "Abnormality",
      notificationtype_memo: "Memo",
      notificationtype_task: "Task",
      notificationtype_internal_message: "Internal Message",
      notificationtype_manufacturer_message: "Manufacturer Message",
      notificationtype_planned_maintenance: "Planned Maintenance",
      notificationtype_maintenance: "Maintenance",
      avg_uptime: "Uptime",
      search_result: { sng: "Search Result", plr: "Search Results" },
      search_empty_title: "No results for “{term}”",
      search_empty_hint:
        "Check the spelling, or search for a machine name, equipment or inventory ID, a notification title or a document.",
      documents: "Documents",
      machines: "Machines",
      messages: "Messages",
      all_categories: "all categories",
      profile_settings: "Profile & Settings",
      add_machine_photo: "add machine photo",
      add_machine_typenameplate_photo: "machine typenameplate",
      add_user_photo: "add user photo",
      state_open: "open",
      state_closed: "closed",
      state_in_discussion: "in discussion",
      loading: "loading",
      access_denied: "Access Denied!",
      week: "week",
      month: "month",
      add_new_user: "add new user",
      first_name: "First Name",
      last_name: "Last Name",
      user_list: "User List",
      please_fill_name: "Please fill name field.",
      backLink: "Back",
      create_new_area: "Create New Area",
      area_name: "Area name",
      area_id: "Area ID",
      e_g_area_1: "e.g. Area 1",
      e_g_area_id: "e.g. 1233",
      button_create_area: "Create area",
      manage_machine_parks: "Manage machine parks",
      manage_machine_park: "Manage machine park",
      create_machine: "Create Machine",
      department: "Department (optional)",
      manufacturer_name: "Manufacturer name",
      e_g_casing_machining: "e.g. Casing Machining",
      internal_id: "ID",
      e_g_internal_id: "e.g. 5214",
      invetory_id: "Inventory ID",
      e_g_inventory_id: "e.g. 1234",
      memo_field: "Memo",
      enter_memo: "Enter note...",
      button_create_machine: "Create machine",
      create_equipment_pool: "Create Machine Park",
      equipment_pool_name: "Machine park name",
      equipment_pool_id: "Machine park ID",
      e_g_equipment_pool_id: "e.g. 1234",
      button_create_equipment_pool: "Create machine park",
      create_new_site: "Create New Size",
      site_name: "Site name",
      e_g_site_name: "e.g. Site 1",
      city: "City",
      e_g_city: "e.g. Birmingham",
      site_zip: "Site ZIP Code",
      e_g_site_zip: "e.g. B1 1DA",
      street: "Street",
      e_g_street: "e.g. Bristol St.",
      house_number: "House Number",
      e_g_house_number: "e.g. 8",
      site_id: "Site ID",
      e_g_site_id: "e.g. 1234",
      button_create_site: "Create site",
      statistics_since_initial_operation: "Statistics since Initial Operation",
      manufacturer_website: "Manufacturer web site",
      click_or_dragdrop: "Click or drag-and-drop",
      download: "Download",
      page: "Page",
      ofPage: "of",
      previous: "Previous",
      next: "Next",
      file_title: "File Title",
      file_description: "File description",
      upload_internal_file: "Upload Internal File",
      show_qr_code: "show QR code",
      show_type_plate: "show type plate",
      show_more_info: "show more info",
      all_areas: "all Areas",
      more_filter_sorting: "more Filters & Sorting",
      button_create_equipment: "Create equipment",
      typing: "typing…",
      write_a_message: "Write a message…",
      role: "Role",
      phone_number_mobile: "Cellphone Number",
      phone_number_landline: "Landline Number",
      info_notification_status:
        "You automatically receive status updates for the machines assigned to you.",
      your_machines: "Your Machines",
      min_n_characters: "Minimum 8 characters",
      button_create_account: "Create Account",
      load_older_notifications: "load older notifications",
      tab_sites: "Sites",
      tab_admin: "Admin Area",
      area: "Area",
      area_heading: "Area",
      open_menu: "Open menu",
      corporate_email: "Corporate email address",
      //create client labels
      create_client_name: "Client Name",
      create_client_billinginformation: "Billing Information",
      create_client_licenseinformation: "License Information",
      create_client_legalentityname: "Legal Entity Name",
      create_client_domain: "Domain",
      create_client_address: "Address",
      tab_overview: "Overview",
      tab_discussion: "Discussion",
      heading_photos: "Photos",
      heading_videos: "Videos",
      button_upload_photo: "Upload photo",
      button_upload_video: "Upload video",
      button_upload_attachment: "Upload attachment",
      image_here: "Image here",
      none_uploaded: "None uploaded",
      empty_discussion: "So far, this issue was not discussed.",
      tab_history: "History",
      tab_description: "Description",
      tab_execution: "Execution",
      notification_not_found_title: "Notification not found",
      notification_not_found_text: "This notification no longer exists, or you can't open it.",
      notification_load_error_title: "Notification could not be loaded",
      notification_load_error_text: "Please try again in a moment.",
      notification_go_back: "Back",
      notification_retry: "Try again",
      tab_documentation: "Documentation",
      tab_faq: "FAQ",
      tab_maintenance: "Maintenance",
      till_now: "Till now",
      create_site: "Create site",
      create_area: "Create area",
      all_sites: "all Sites",
      manufacturer: "Hersteller",
      internal_machine_name: "Internal Machine Name (optional)",
      heading_your_profile: "Your Profile",
      heading_safety: "Safety",
      additional_details: "Additional Details",
      photo: "Photo",
      add_solution: "Add Solution",
      workflow_step_desc: "Description",
      save_solution: "Save Solution",
      save_FAQ: "Save FAQ",
      workflow_title: "Workflow Title",
      no_workflow_title: "No Title",
      notification_solutions: "Notification Solutions",
      none_solution: "No Solution",
      edit_solution: "Edit Solution",
      internal_faqs: "Internal FAQs",
      manufacturer_faqs: "Manufacturer FAQs",
      update_faq: "EDIT",
      clear_faq: "DELETE",
      add_new_faq: "add new FAQ",
      add_faq: "Add FAQ",
      edit_faq: "Edit FAQ",
      faq_question: "Question",
      faq_answer: "Answer",
      maintenance: "Maintennance",
      new_maintenance: "Neue Wartung",
      history_title: "Maschinenhistorie",
      maintenance_desc:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt. Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung.",
      history_description:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind.",
      counter_desc:
        "Zähler helfen Ihnen dabei,  wichtige Kennzahlen wie zum Beispiel Betriebsstunden zu registrieren und im Blick zu behalten.",
      new_maintenance_create: "Neue Wartung erstellen",
      maintenance_title: "Maintenance Title",
      maintenance_title_helperText: 'e.g .: "Major Inspection"',
      maintenance_category: "Maintenance Category",
      maintenance_category_manage: "Manage Categories",
      maintenance_category_manage_title: "Manage Maintenance Categories",
      maintenance_category_new_title: "Create a new category",
      maintenance_category_title: "Category Name",
      maintenance_category_title_helperText: "e.g.: “ISO “45001",
      maintenance_category_btn_save: "Create a category",
      maintenance_category_delete: "Delete Category",
      maintenance_category_edit: "Edit Category",
      dropzone_dialog_title: "Drop file to upload",
      maintenance_date: "First Appointment",
      maintenance_repetition: "Cycle of Repetition",
      maintenance_reminder: "Reminder Before Appointment",
      maintenance_description: "Maintenance Description",
      safty_instructions: "Safety Instructions",
      safty_instructions_placeholder: "Enter safety instructions (optional)...",
      maintenance_create_btn: "Create Maintenance",
      maintenance_update_btn: "Update Maintenance",
      maintenance_repetition_yearly: "Yearly",
      maintenance_repetition_onetime: "One Time",
      maintenance_repetition_oneweek: "One Week",

      maintenance_repetition_oneweek: "Two Weeks",

      maintenance_repetition_month: "Month",
      maintenance_repetition_months: "Months",
      maintenance_reminder_Week: "Week",
      maintenance_reminder_days: "Days",

      maintenance_reminder_Weeks: "Weeks",
      maintenance_reminder_month: "Month",
      maintenance_next_termine: "next appointment",
      maintenance_report: "Implementation Protocol",
      maintenance_report_empty:
        "There is still no record of a previous inspection.",
      maintenance_report_add_btn: "Create Report",
      protocol_executed: "Execution Date",
      create_report__title: "Report Creation",
      edit_report_title: "Report Editing",
      protocol_comments: "Enter comment...",
      protocol_title_pretext: "Reported on",
      protocol_title_posttext: "of",
      protocol_description: "Summary",
      protocol_update: "Update Protocol",
      menu_Instandhaltung: "Maintenance",
      menu_Instandhaltung_submenu: "Notifications",
      menu_Instandhaltung_submenu1: "Planned Maintenance",
      menu_Instandhaltung_submenu2: "Task planning",

      no_maintenancetask: "No Maintenancetask Available",
      edit_equipment: "Edit Equipment",
      edit: "Update",
      dropzone_dialog_title: "Drop file to upload",
      delete: "Delete",
      nav_machinetype: "Machine Type",
      nav_customermachines: "Customer Machines",
      nav_customermachines_allmachine: "All Machines",
      nav_customermachines_analysis: "Analysis",
      personal_number: "Personnel number (optional)",
      details_comment: "Enter qualifications (optional)...",
      specialization: "Fachausrichtung (optional)",
      nav_servicemanagement: "Service Management",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",
      create_equipment_type: "Create Equipment Type",
      update_equipment_type: "Update Equipment Type",
      delete_equipment_type: "Delete Equipment Type",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Customer Equipments",
      customer_contact: "Customer Contact",

      history_filter_created: "Created",
      history_filter_closed: "abgeschlossen",
      history_filter_type: "Type",
      history_filter_status: "Status",
      history_filter_keyword: "Keyword",
      history_filter_reset: "Reset",
      history_filter_export: "Export Selection",
      history_filter_actions: "Actions",
      systemCreated: "System Created",
      allMachines: "All Equipments",
      allMachinePools: "All Equipment Pools",
      allSites: "All Sites",
      no_open_notification: "No Open Notication",

      no_data: "No Data",
      admin_search_placeholder: "Search users",

      admin_scope_header_0: "Administration",
      admin_scope_header_desc_0:
        "Hier verwalten Sie Ihr Abo und alle Benutzer.",

      admin_scope_header_1: "Administration",
      admin_scope_header_desc_1: "Hier verwalten Sie alle Benutzer.",

      // General Maintenance Tasks (pool/area-level maintenance)
      gmt_tab_equipment: "Equipment",
      gmt_tab_tasks: "Maintenance",
      gmt_dashboard_heading: "General tasks",
      gmt_calendar_general: "General",
      gmt_tasks_loading: "Loading maintenance tasks…",
      gmt_show_completed: "Show completed maintenance",
      gmt_history_loading: "Loading completed maintenance…",
      gmt_history_load_error: "The completed maintenance could not be loaded.",
      gmt_timerange_all: "All time",
      gmt_duration_day_short: "d",
      gmt_new_task: "New maintenance",
      gmt_col_title: "Title",
      gmt_col_next_execution: "Next execution",
      gmt_col_repetition: "Repetition",
      gmt_col_reminder: "Reminder",
      gmt_col_category: "Category",
      gmt_entries_per_page: "entries per page",
      gmt_no_tasks: "No tasks are planned for this machine park yet.",
      gmt_save_error_title: "Saving failed",
      gmt_delete_error_title: "Deleting failed",
      gmt_save_error_desc: "The maintenance task could not be saved. Please try again.",
      gmt_load_error: "The maintenance tasks could not be loaded.",
      gmt_form_desc:
        "All users registered for this machine park receive a reminder to carry out the maintenance.",
      gmt_history_title: "Maintenance history",
      gmt_history_desc:
        "Here you find an overview of all planned maintenances that were carried out.",
      gmt_history_today: "Today",
      gmt_history_planned_for: "planned for",
      gmt_history_done_on: "done on",
      gmt_history_solution_time: "Solution time",
      gmt_history_load_more: "Load more",
      gmt_history_empty: "No executions yet.",
      gmt_filter_toggle: "Filter & Export",
      gmt_filter_all: "All",
      gmt_filter_start_date: "Start date",
      gmt_filter_end_date: "End date",
      gmt_history_no_matches: "No executions match the filter.",
    },

    // German language
    de: {
      dropzone_dialog_title: "Datei fallen lassen, um hochzuladen",

      change_password: "Kennwort ändern",
      update_user: "Benutzer bearbeiten",
      year: "Jahr",

      admin_search_placeholder: "Benutzer durchsuchen",
      dropzone_dialog_title: "Datei fallen lassen, um hochzuladen",
      no_data: "Keine Daten",

      admin_scope_header_0: "Administration",
      admin_scope_header_desc_0:
        "Hier verwalten Sie Ihr Abo und alle Benutzer.",

      admin_scope_header_1: "Administration",
      admin_scope_header_desc_1: "Hier verwalten Sie alle Benutzer.",

      user_table_status: "status",
      user_table_Vorname: "Vorname",
      user_table_Nachname: "Nachname",
      user_table_Benutzertyp: "Benutzertyp",
      user_table_email: "E-Mail-Adresse",

      land_germany_name: "Deutschland",
      land_germany_value: "en",

      land_austria_name: "Österreich",
      land_austria_value: "en",

      land_swiss_name: "schweizerisch",
      land_swiss_value: "en",

      land_checkrepulic_name: "czeckreuplic",
      land_checkrepublic_value: "en",

      land_poland_name: "Polen",
      land_poland_value: "de",

      create_site_title: "Neues Werk anlegen",
      update_site_title: "Werk bearbeiten",

      create_area_title: "Neuen Bereich anlegen",
      update_area_title: "Bereich bearbeiten",

      create_equipment_title: "Neues Equipment anlegen",

      dashboard_initial_factory_title: "Werke und Bereiche anlegen",
      dashboard_initial_equipment_title: "Equipment Pools anlegen",
      dashboard_initial_users_title: "Weitere 247UpTime-Benutzer erstellen",
      dashboard_initial_final_title: "Equipment anlegen und zuordnen",

      dashboard_initial_state_title:
        "Guten Tag, %s!<br> Fahren Sie mit der Einrichtung von 247UpTime fort.",
      dashboard_initial_state_description:
        "Sie können nach der erstmaligen Einrichtung jederzeit weitere Werke, Equipment und Benutzer erstellen.",

      construction_year: "Baujhar",
      carry_now: "jetzt durchführen",
      empty_dashboard_button: "Profil & einstellungen Öffnen",
      empty_dashboard_title: "Sie haben noch keine Maschinen abonniert",
      empty_dashboard_desc:
        "Um Maschinen zu abonnieren müssen Sie in Ihrem Userprofil im Bereich , Ihre Maschinen die für Sie relevanten Werke oder Maschinen Pools auswählen.",
      footer_contact: "Kontakt",
      footer_data_protection: "Datenschutz",
      footer_impressum: "Impressum",
      equipment_serial_number: "Seriennummer",
      counter_Type: "Zählertyp",
      sites: "Werke",
      export_machine_details: "Export Ihrer Daten",
      no_notifications:
        "Keine neuen Benachrichtigungen. Wir benachrichtigen Sie, sobald es neue Vorfälle gibt.",
      add_new_counter: "NEU",
      tab_counters: "Zähler",
      streetnumber: "Straße",
      postalCode: "Postleitzahl",
      city: "Stadt",
      land: "Land",
      reported: "Gemeldet",
      firmName: "Firm Name",
      homePage: "Startseite",
      firm_details: "DETAILS ZU IHRER FIRMA",
      email: "E-Mail-Adresse",
      password: "Passwort",
      forgot_password: "Passwort vergessen?",
      loginHeading: "Login",
      loginButton: "Einloggen",
      registration: "Registrieren",
      no_account: "SIE HABEN NOCH KEINEN ACCOUNT?",
      required_field: "Pflichtfeld",
      register_for_free: "Kostenfrei registrieren",
      searchplaceholder_tablet: "Suchen nach Maschinen, Meldungen, …",
      searchplaceholder_phone: "Suchen nach Maschinen, Meldungen, …",
      createnewissue: "Neue Meldung erstellen",
      update_notification: "Meldung Bearbeiten",
      machineparks: "Maschinenparks",
      machinepark: "Maschinenpark",
      all_machineparks: "Alle Equipment Pools",
      factorysections: "Werksabschnitte",
      machinecategory: "Maschinenkategorie",
      machinestatus: "Maschinenstatus",
      groupby: "Gruppieren nach",
      timerange: "Zeitraum",
      show_n_more: "%s weitere anzeigen",
      show_less: "Weniger anzeigen",
      no_notifications:
        "Keine neuen Benachrichtigungen. Wir benachrichtigen Sie, sobald es neue Vorfälle gibt.",
      add_new_counter: "NEU",
      streetnumber: "Straße",
      postalCode: "Postleitzahl",
      city: "Stadt",
      land: "Land",
      reported: "Gemeldet",
      firmName: "Firm Name",
      homePage: "Startseite",
      firm_details: "DETAILS ZU IHRER FIRMA",
      email: "E-Mail-Adresse *",
      password: "Passwort",
      forgot_password: "Passwort vergessen?",
      loginHeading: "Login",
      loginButton: "Einloggen",
      trialButton: "30 Tage Kostenfrei Testen",
      companyName: "Unternehmen",
      signUpHeading: "Neuen Account erstellen",
      signUpHeading2:
        "Nur noch ein Schritt, um Ihre Registrierung abzuschließen",
      createAccount: "Account Erstellen",
      toLogin: "Zum Login",
      businessEmail: "Geschäfliche E-Mail-Adresse",
      registration: "Registrieren",
      no_account: "SIE HABEN NOCH KEINEN ACCOUNT?",
      required_field: "Pflichtfeld",
      register_for_free: "Kostenfrei registrieren",
      searchplaceholder_tablet: "Suchen nach Maschinen, Meldungen, …",
      searchplaceholder_phone: "Suchen nach Maschinen, Meldungen, …",
      createnewissue: "Neue Meldung erstellen",
      update_notification: "Meldung Bearbeiten",
      opennotifications: "Offene Meldungen",
      machineparks: "Maschinenparks",
      machinepark: "Maschinenpark",
      all_machineparks: "Alle Equipment Pools",
      factorysections: "Werksabschnitte",
      machinecategory: "Maschinenkategorie",
      machinestatus: "Maschinenstatus",
      groupby: "Gruppieren nach",
      timerange: "Zeitraum",
      show_n_more: "%s weitere anzeigen",
      show_less: "Weniger anzeigen",
      //empty_notifications: 'Es gibt derzeit keine ungelösten Probleme. Weiter so!',
      empty_notifications: "derzeit keine",
      notification_singular: "Meldung",
      notification_plural: "Meldungen",
      //avg_solutiontime: 'Ø Maßnahmeszeit',
      avg_solutiontime: "MTTR",
      incidents: "Störfälle",
      statistics: "Statistiken",
      new_issue: "Neue Meldung",
      create_new_notification: "Neue Meldung erstellen",
      save_notification: "Speichern",
      save: "Speichern",
      next_appointment: "Nächster Termin",
      due_on: "Fällig am",
      rotation: "Turnus",
      filter_sorting: "Filter & Sortierung",
      filter: "Filter",
      sorting: "Sortierung",
      unresolved: "ungelöst",
      day: "Tag",
      days: "Tage",
      empty_machineparks:
        "Es sind noch keine Maschinenparks eingerichtet worden. Wenden Sie sich bitte an den Administrator.",
      undisturbed: "störungsfrei",
      disturbed: "Störung",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Maschinenparks",
      tab_messages: "Nachrichten",
      super_tab_clients: "Kunden",
      super_tab_users: "Benutzer",
      super_tab_brands: "Marken",
      super_tab_equipment_types: "Gerätetypen",
      tab_notifications: "Mitteilungen",

      manufacturer_serial_number: "Hersteller-Seriennummer",
      heading_latest_notifications: "Aktuelle Meldungen & geplante Wartungen",
      go_to_machine_history: "Zur Maschinenhistorie",
      heading_responsible: "Verantwortlich",
      heading_manufacturer_service: "Hersteller-Service",
      heading_life_cycle: "Lebenslauf",
      notificationtype: "Meldungstyp",
      built_year: "Baujahr",
      empty_history:
        "Die Maschinenhistorie weißt bisher noch keine Meldungen auf.",
      today: "Heute",
      heading_documentation: "Dokumentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Dokument",
      file_ods: "ODS Spreadsheet",
      file_image: "Bild",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interne Ressourcen",
      hasmanufacturerattchment: "Hersteller Ressourcen",
      add_new_resource: "neue Ressource hinzufügen",
      add_ressource: "Ressource hinzufügen",
      upload_file: "Datei hochladen",
      resource_vendor: "Zuordnung",
      resource_type: "Typ",
      resource_type_file: "Datei",
      resource_type_link: "Link",
      resource_type_photo: "Foto",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Datei ändern",
      resource_name: "Titel der Ressource",
      resource_description: "Beschreibung (optional)",
      resource_language: "Sprache",
      resource_scope: "Gültigkeitsbereich",
      button_cancel: "abbrechen",
      button_yes: "Ja",
      button_no: "Nein",
      empty_resources:
        "Bisher wurden dieser Maschine noch keine Ressourcen hinzugefügt.",
      button_done: "Fertig",
      select_multiple_n: "mehrere (%s)",
      header_data: "Kopfdaten",
      referred_to_machine: "Betreffende Maschine",
      notification_title: "Titel der Meldung",
      helpertext_notification_title: 'z. B.: "Hauptspindel defekt"',
      referred_to_assembly: "Betroffene Baugruppe",
      date: "Datum",
      time: "Zeit",
      problem_solution_status: "Status",
      notification_description: "Beschreibung",
      error_code: "Fehlercode (optional)",
      describe_notification: "Beschreiben Sie die Meldung…",
      add_photos_videos: "Fotos/Videos hinzufügen",
      capture_photo: "Neues Foto aufnehmen",
      capture_video: "Neues Video aufnehmen",
      add_from_gallery: "Von Galerie hinzufügen",
      add_attachments: "Anhänge hinzufügen",
      enter_description: "Beschreibung eingeben…",
      change_attachments: "Anhänge ändern",
      notification_sucessfully_created: "Die Meldung wurde erfolgreich erfasst",
      discuss_notification: "Meldung besprechen",
      go_to_machine: "zur Maschine",
      notificationtype_from: "%notificationtype vom %datetime",
      reported_by: "gemeldet durch",
      machine: "Maschine",
      images: "Bilder",
      no_images_yet: "Dieser Meldung wurden noch keine Bilder hinzugefügt.",
      attachments: "Anhänge",
      edit_notification: "Meldung bearbeiten",
      notification_solved: "Die Meldung wurde erfolgreich gelöst.",
      close_notification_heading: "Meldung schließen",
      close_notification_text:
        "Möchten Sie die Meldung als gelöst kennzeichen und alle Beteiligten Instanzen darüber informieren?",
      settings: "Einstellungen",
      chat_notifications: "Chat-Benachrichtigungen",
      automatic_translation: "Automatische Übersetzung",
      activate: "aktivieren",
      target_language: "Zielsprache",
      involved_contacts_heading: "Beteiligte Kontakte",
      search_contacts: "Kontakte suchen…",
      empty_discussion_contacts:
        "Dieser Diskussion wurden noch keine Kontakte hinzugefügt.",
      discussion_heading: "Diskussion",
      error_chatroom_loading: "Der Chatraum konnte nicht geladen werden.",
      error_email_required: "Bitte E-Mail-Adresse eingeben",
      error_email_format: "Eingegebene E-Mail-Adresse ist ungültig",
      error_password_required: "Bitte Passwort eingeben",
      error_password_wrong: "E-Mail und Passwort stimmen nicht überein.",
      enter_message: "Nachricht eingeben…",
      time_h: "Uhr",
      alert_trash_changes_body:
        "Möchten Sie die von Ihnen vorgenommenen Änderungen verwerfen?",
      button_save_changes: "Änderungen speichern",
      logout: "Logout",
      all_notificationtypes: "alle Meldungstypen",
      notificationtype_malfunction: "Störungen",
      notificationtype_abnormality: "Auffälligkeit",
      notificationtype_memo: "Notizen",
      notificationtype_task: "Aufgabe",
      notificationtype_internal_message: "Interne Mitteilungen",
      notificationtype_manufacturer_message: "Herstellermitteilung",
      notificationtype_planned_maintenance: "Geplante Wartungen",
      notificationtype_maintenance: "Wartungen",
      avg_uptime: "Uptime",
      search_result: { sng: "Suchergebnis", plr: "Suchergebnisse" },
      search_empty_title: "Keine Treffer für „{term}“",
      search_empty_hint:
        "Prüfen Sie die Schreibweise, oder suchen Sie nach einem Maschinennamen, einer Equipment- oder Inventar-ID, einem Meldungstitel oder einem Dokument.",
      documents: "Dokumente",
      machines: "Maschinen",
      messages: "Nachrichten",
      all_categories: "alle Kategorien",
      profile_settings: "Profil & Einstellungen",
      add_machine_photo: "Maschinenfoto hinzufügen",
      add_machine_typenameplate_photo: "Typenschild der Maschine",
      add_user_photo: "Benutzerbild hinzufügen",
      state_open: "offen",
      state_closed: "erledigt",
      state_in_discussion: "in Bearbeitung",
      loading: "Wird geladen",
      access_denied: "Zugriff verwehrt!",
      week: "Woche",
      month: "Monat",
      add_new_user: "Neuen Benutzer hinzufügen",
      first_name: "Vorname",
      last_name: "Nachname",
      user_list: "Benutzerliste",
      please_fill_name: "Bitte vergeben Sie einen Namen.",
      backLink: "Zurück",
      create_new_area: "Neuen Werksabschnitt erstellen",
      area_name: "Werksabschnittsname",
      area_id: "ID des Werksabschnitts",
      e_g_area_1: "z. B. Werk 1",
      e_g_area_id: "z. B. 1233",
      button_create_area: "Abschnitt erstellen",
      manage_machine_parks: "Maschinenparks verwalten",
      manage_machine_park: "Maschinenpark verwalten",
      create_machine: "Maschine anlegen",
      department: "Abteilung (optional)",
      cost_center: "Kostenstelle (optional)",
      manufacturer_name: "Herstellerbezeichnung",
      e_g_casing_machining: "z. B. Gehäusebearbeitung",
      internal_id: "Identifikationsnummer",
      e_g_internal_id: "z. B. 5214",
      invetory_id: "Inventar ID",
      e_g_inventory_id: "z. B. 1234",
      memo_field: "Notizen",
      enter_memo: "Notiz eingeben...",
      button_create_machine: "Maschine anlegen",
      create_equipment_pool: "Maschinenpark anlegen",
      equipment_pool_name: "Name des Maschinenparks",
      equipment_pool_id: "ID des Maschinenparks",
      e_g_equipment_pool_id: "z. B. 1234",
      button_create_equipment_pool: "Maschinenpark anlegen",
      create_new_site: "Neues Werk anlegen",
      site_name: "Name des Werkes",
      e_g_site_name: "z. B. Werk 1",
      city: "Ort",
      e_g_city: "z. B. Ingolstadt",
      site_zip: "Postleitzahl des Werkes",
      e_g_site_zip: "z. B. 85053",
      street: "Straße",
      e_g_street: "z. B. Münchner Straße",
      house_number: "Hausnummer",
      e_g_house_number: "z. B. 8",
      site_id: "ID des Werkes",
      e_g_site_id: "z. B. 1234",
      button_create_site: "Werk anlegen",
      statistics_since_initial_operation: "Statistik seit Inbetriebnahme",
      manufacturer_website: "Hersteller-Webseite",
      click_or_dragdrop: "Klicken oder Drag-and-Drop",
      download: "Download",
      page: "Seite",
      ofPage: "von",
      previous: "Zurück",
      next: "Weiter",
      file_title: "Dateititel",
      file_description: "Beschreibung",
      upload_internal_file: "Interne Datei hochladen",
      show_qr_code: "QR-Code anzeigen",
      show_type_plate: "Typenschild anzeigen",
      show_more_info: "mehr Infos anzeigen",
      all_areas: "Alle Bereiche",
      more_filter_sorting: "mehr Filter & Sortierung",
      button_create_equipment: "Maschine erstellen",
      typing: "schreibt…",
      write_a_message: "Schreiben Sie eine Nachricht…",
      role: "Rolle",
      phone_number_mobile: "Handynummer",
      phone_number_landline: "Festnetz",
      info_notification_status:
        "Sie erhalten automatisch Statusupdates für die für Sie zugewiesenen Maschinen.",
      your_machines: "Ihre Maschinen",
      min_n_characters: "Mindestens 8 Zeichen",
      button_create_account: "Account erstellen",
      load_older_notifications: "ältere laden",
      tab_sites: "Werke",
      tab_admin: "Adminbereich",
      area: "Werksabschnitt",
      area_heading: "Werksabschnitt",
      open_menu: "Menü öffnen",
      corporate_email: "Unternehmens-E-Mail-Adresse",
      //create client labels
      create_client_name: "Kundenname",
      create_client_billinginformation: "Abrechnungsdaten",
      create_client_licenseinformation: "Lizenzinformationen",
      create_client_legalentityname: "Offizielle Unternehmensbezeichnung",
      create_client_domain: "Domain",
      create_client_address: "Adresse",
      tab_overview: "Übersicht",
      tab_discussion: "Diskussion",
      heading_photos: "Fotos",
      heading_videos: "Videos",
      button_upload_photo: "Foto hochladen",
      button_upload_video: "Video hochladen",
      button_upload_attachment: "Anhang hochladen",
      image_here: "Bild hier",
      none_uploaded: "Keine hochgeladen",
      empty_discussion: "Bisher wurde diese Meldung noch nicht diskutiert.",
      tab_history: "Historie",
      tab_description: "Beschreibung",
      tab_execution: "Durchführung",
      notification_not_found_title: "Meldung nicht gefunden",
      notification_not_found_text: "Diese Meldung gibt es nicht mehr, oder Sie können sie nicht öffnen.",
      notification_load_error_title: "Meldung konnte nicht geladen werden",
      notification_load_error_text: "Bitte versuchen Sie es gleich noch einmal.",
      notification_go_back: "Zurück",
      notification_retry: "Erneut versuchen",
      tab_documentation: "Dokumentation",
      tab_faq: "FAQ",
      tab_maintenance: "Wartungen",
      till_now: "Bis jetzt",
      create_site: "Werk erstellen",
      create_area: "Werksabschnitt erstellen",
      all_sites: "alle Werke",
      manufacturer: "Hersteller",
      internal_machine_name: "Interner Maschinenname (optional)",
      heading_your_profile: "Ihr Profil",
      heading_safety: "Sicherheit",
      additional_details: "Zusätzliche Details",
      photo: "Foto",
      add_solution: "Maßnahme Hinzufügen",
      workflow_step_desc: "Beschreibung",
      save_solution: "Maßnahme Speichern",
      workflow_title: "Workflow-Titel",
      no_workflow_title: "Kein Titel",
      notification_solutions: "Vorgehensbeschreibung",
      none_solution: "Keine Maßnahme",
      edit_solution: "Maßnahme Bearbeiten",
      internal_faqs: "Intern FAQs",
      manufacturer_faqs: "Hersteller FAQs",
      update_faq: "BEARBEITEN",
      clear_faq: "LÖESCHEN",
      add_new_faq: "neue FAQ",
      add_faq: "FAQ hinzufügen",
      edit_faq: "FAQ bearbeiten",
      faq_question: "Frage",
      faq_answer: "Anwort",
      save_FAQ: "FAQ speichern",
      maintenance: "Routinewartungen",
      new_maintenance: "Neue Wartung",
      history_title: "Maschinenhistorie",
      history_description:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind.",
      maintenance_desc:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt. Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung.",
      counter_desc:
        "Zähler helfen Ihnen dabei,  wichtige Kennzahlen wie zum Beispiel Betriebsstunden zu registrieren und im Blick zu behalten.",
      new_maintenance_create: "Neue Wartung erstellen",
      maintenance_title: "Titel der Wartung",
      maintenance_title_helperText: "z.B.: “Große Inspektion”",
      maintenance_category: "Kategorie der Wartung",
      maintenance_category_manage: "Kategorien verwalten",
      maintenance_category_manage_title: "Wartungs-Kategorien verwalten",
      maintenance_category_new_title: "Neue Kategorie anlegen",
      maintenance_category_title: "Name der Kategorie",
      maintenance_category_title_helperText: "z.B.: “ISO “45001",
      maintenance_category_btn_save: "Kategorie anlegen",
      maintenance_category_delete: "Kategorie löschen",
      maintenance_category_edit: "Kategorie editieren",
      maintenance_date: "Erster Termin",
      maintenance_repetition: "Turnus der Wiederholung",
      maintenance_reminder: "Erinnerung vor Termin",
      safty_instructions_placeholder:
        "Sicherheitshinweise (optional) eingeben...",
      maintenance_description: "Beschreibung der Wartung",
      safty_instructions: "Sicherheitshinweise",
      maintenance_create_btn: "Wartung erstellen",
      maintenance_update_btn: "SPEICHERN",
      maintenance_repetition_yearly: "jährlich",
      maintenance_repetition_onetime: "einmalig",
      maintenance_repetition_oneweek: "Woche",

      maintenance_repetition_twoweek: "Wochen",
      maintenance_repetition_sixweek: "Wochen",

      maintenance_repetition_month: "Monat",
      maintenance_repetition_months: "Monate",
      maintenance_reminder_Week: "Woche",
      maintenance_reminder_Weeks: "Wochen",
      maintenance_reminder_Days: "Tage",
      maintenance_reminder_month: "Monat",
      maintenance_next_termine: "nächster Termin",
      maintenance_report: "Report",
      maintenance_report_empty: "Es wurde noch kein Report erstellt.",
      maintenance_report_add_btn: "Report erstellen",
      protocol_executed: "Ausführungsdatum",
      // protocol_title: "Bericht Erstellen",
      create_report__title: "Report erstellen",
      edit_report_title: "Report bearbeiten",
      protocol_comments: "Bermerkung eingeben...",
      protocol_title_pretext: "Durchgeführt am",
      protocol_title_posttext: "von",
      protocol_description: "Zusammenfassung",
      protocol_update: "Report Bearbeiten",
      menu_Instandhaltung: "Instandhaltung",
      menu_Instandhaltung_submenu: "Meldungen",
      menu_Instandhaltung_submenu1: "Geplante Wartungen",
      menu_Instandhaltung_submenu2: "Aufgabenplanung",

      no_maintenancetask: "Keine Wartungsaufgabe verfügbar",
      edit_equipment: "Speichern",
      edit: "Bearbeiten",
      delete: "Löschen",
      nav_machinetype: "Maschinentypen",
      nav_customermachines: "Kundenmaschinen",
      nav_customermachines_allmachine: "Alle Maschinen",
      nav_customermachines_analysis: "Analyse",
      nav_servicemanagement: "Servicemanagement",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",
      create_equipment_type: "Create MachinenTypen",
      update_equipment_type: "Update MachinenTypen",
      delete_equipment_type: "Delete MachinenTypen",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Kundenmaschinen",
      customer_contact: "Kundenkontakt",

      history_filter_created: "Erstellt",
      history_filter_closed: "abgeschlossen",
      history_filter_type: "Typ",
      history_filter_status: "Status",
      history_filter_keyword: "Stichwort",
      history_filter_reset: "zurücksetzen",
      history_filter_export: "Auswahl exportieren",
      history_filter_actions: "PDF erzeugen",
      systemCreated: "System Created",
      allMachines: "Alle Maschinen",
      allMachinePools: "Alle Maschinenparks",
      allSites: "Alle Werke",
      no_open_notification: "keine offen meldung",
      abo_title: "IHR 247UPTIME ABO",
      abo_complete_title: "247UpTime Abo abschließen",
      number_of_packages: "Anzahl Pakete",
      total_price: "Gesamtpreis (netto) pro Monat",
      billing_address_title: "Rechnungsadresse",
      companyName: "Unternehmen *",
      street_and_house_number: "Straße und Hausnummer *",
      post_code: "PLZ *",
      city: "Ort *",
      address_supplement: "Adresszusatz (optional)",
      land: "Land",
      emailEmail_for_invoicing: "E-Mail für Rechnungsstellung",
      contact_person: "Ansprechpartner",
      firstName: "Vorname *",
      lastName: "Nachname *",
      department: "Abteilung (optional)",
      cost_center: "Kostenstelle (optional)",
      personal_number: "Personal-Nummer (optional)",
      details_comment: "Qualifikationen (optional) eingeben...",
      specialization: "Fachausrichtung (optional)",
      telephoneNumber: "Telefonnumer",
      customer_service_title: "Sie haben Fragen?",
      customer_service_number: "+49 (0)8158 9239817",
      customer_service_email: "247uptime@247factorynet.com",
      customer_service_time: "Mo.–Fr. 09–18 Uhr",
      your_advantage: "IHRE VORTEILE",
      choose_subscription_title: "Gewünschtes Abo wählen",
      select_package: "Anzahl der Pakete wählen",
      invoice_title: "Rechnungsstellung",
      invoice_address: "Rechnungsadresse",
      invoice_edit: "Bearbeiten",
      purchaseComplete_title: "Kauf abschließen",
      order_title: "Vielen Dank für Ihre Bestellung",
      order_finished_message:
        "Die Bestellung des Abonnements ist abgeschlossen. Kehren Sie zur mobilen App zurück.",
      documentationTab_dragAndDrop_text:
        "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      documentationTab_dragAndDrop_caption:
        "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien",
      dragAndDrop_btn: "+ DATEI HOCHLADEN",

      // General Maintenance Tasks (Wartungen auf Maschinenpark-Ebene)
      gmt_tab_equipment: "Equipment",
      gmt_tab_tasks: "Wartungen",
      gmt_dashboard_heading: "Allgemeine Aufgaben",
      gmt_calendar_general: "Allgemein",
      gmt_tasks_loading: "Wartungsaufgaben werden geladen…",
      gmt_show_completed: "Zeige abgeschlossene Wartungen",
      gmt_history_loading: "Abgeschlossene Wartungen werden geladen…",
      gmt_history_load_error: "Die abgeschlossenen Wartungen konnten nicht geladen werden.",
      gmt_timerange_all: "Gesamt",
      gmt_duration_day_short: "T",
      gmt_new_task: "Neue Wartung",
      gmt_col_title: "Titel",
      gmt_col_next_execution: "Nächste Durchführung",
      gmt_col_repetition: "Wiederholung",
      gmt_col_reminder: "Erinnerung",
      gmt_col_category: "Kategorie",
      gmt_entries_per_page: "Einträge pro Seite",
      gmt_no_tasks: "Für diesen Maschinenpark sind noch keine Aufgaben geplant.",
      gmt_save_error_title: "Speichern fehlgeschlagen",
      gmt_delete_error_title: "Löschen fehlgeschlagen",
      gmt_save_error_desc: "Die Wartungsaufgabe konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      gmt_load_error: "Die Wartungsaufgaben konnten nicht geladen werden.",
      gmt_form_desc:
        "Alle für diesen Maschinenpark registrierten User erhalten eine Erinnerung zur Ausführung der Wartung.",
      gmt_history_title: "Wartungshistorie",
      gmt_history_desc:
        "Hier finden Sie eine Übersicht aller geplanten Wartungen, die durchgeführt wurden.",
      gmt_history_today: "Heute",
      gmt_history_planned_for: "geplant für",
      gmt_history_done_on: "erledigt am",
      gmt_history_solution_time: "Lösungszeit",
      gmt_history_load_more: "Weitere laden",
      gmt_history_empty: "Noch keine Durchführungen.",
      gmt_filter_toggle: "Filter & Export",
      gmt_filter_all: "Alle",
      gmt_filter_start_date: "Startdatum",
      gmt_filter_end_date: "Enddatum",
      gmt_history_no_matches: "Keine Durchführungen entsprechen dem Filter.",
    },
  };

  return localizedStrings[language];
}

export default i18n;
